/**
 * Commerce7 Collection Filter - clear filter handle
 */
const C7BaseUrl = "https://api.commerce7.com/v1";

import { renderVivinoScore } from "./c7-util";

export default function C7Collection() {
	const winesData = {};

	const selectors = {
		banner: ".c7-product-collection__banner",
		clearFilter: ".c7-product-collection__clear-filter",
		collection: ".c7-product-collection",
		filter: ".c7-selectbox",
		filterContainer: ".c7-product-collection__wine_filters",
		filterInput: ".c7-product-collection__wine_filters input",
		filterInputAll: "input.all",
		filterInputOption: "input:not(.all)",
		filterInputSelected: "input:not(.all):checked",
		noResult: ".c7-product-collection__no-result",
		product: ".c7-product",
		productsContainer: ".c7-product-collection__products",
		productInformation: ".c7-product-information",
		productPrice: ".c7-product__variant__price",
		sort: ".c7-selectbox--sort",
		sortInput: ".c7-selectbox--sort input",
		selectboxLabel: ".c7-selectbox label",
		close: ".c7-product-collection__filter .icon-close",
		open: ".c7-product-collection__filter .collection__filter__mobile",
		searchContainer: ".collection-search-container",
		clearSearch: ".collection__clear-search",
		searchInput: ".collection__search-input",
	};

	const wineFilter = [
		{ name: "wineType", fetchLink: "wine-type", label: "Type" },
		{
			name: "wineVarietal",
			fetchLink: "wine-varietal",
			label: "Varietal",
		},
		{
			name: "wineCountryCode",
			fetchLink: "wine-country-code",
			label: "Country",
		},
		{ name: "wineRegion", fetchLink: "wine-region", label: "Region" },
		{
			name: "wineAppellation",
			fetchLink: "wine-appellation",
			label: "Appellation",
		},
		{
			name: "wineVintage",
			fetchLink: "wine-vintage",
			label: "Vintage",
		},
	];

	this.init = () => {
		c7.addAction("c7_collection_products_rendered", (collection) => {
			// Check if the collection has filter.
			if (+collection.dataset.hasFilter) {
				makeFilters(collection);
				makeSort(collection);
				registerEventHandlers();
			}

			updateBannerPosition(collection);
			renderVivinoScore(collection);
		});
	};

	/**
	 * Update wine nodes for price sort.
	 *
	 * @param {Node} collection
	 */
	const makeSort = (collection) => {
		/* Store sorted prices */
		const prices = [];
		const wines = $(collection).find(selectors.product);
		wines.each((index, wine) => {
			const price = +$(wine)
				.find(selectors.productPrice)
				.text()
				.split("$")
				.slice(-1)[0];

			prices.push({ index, price });
		});

		prices.sort((a, b) => a.price - b.price);

		prices.forEach((price, order) => {
			const wine = wines.eq(price["index"]);
			wine.attr(
				"data-price-order",
				wine.hasClass("c7-product--featured") ? wines.length : order
			);
		});

		/* Make checkboxes */
		let str = `<div><input class="all" type="checkbox" name="sort" value="none" checked><span>None</span></div>
			<div><input type="checkbox" name="sort" value="priceup"><span>Price low to high</span></div>
			<div><input type="checkbox" name="sort" value="pricedown"><span>Price hight to low</span></div>`;
		$(selectors.sort).append(
			`<div class="c7-selectbox__inner">${str}</div>`
		);
	};

	/**
	 * Insert banner into the position if it does exist.
	 *
	 * @param {Node} collection
	 */
	const updateBannerPosition = (collection) => {
		const banner = collection.querySelector(selectors.banner);
		if (!banner) {
			return;
		}

		const products = $(collection).find(selectors.product);
		let pos = banner.dataset.rows;

		if (window.innerWidth > 1023) {
			const position = banner.dataset.rows * 2;
			let cards = 0;
			for (let index in products) {
				cards += $(products[index]).hasClass('c7-product--featured') ? 2 : 1;
				if (cards > position) {
					pos = index;
					break;
				}
			}
		}

		$(banner).insertBefore(products.eq(pos));
		$(banner).show();
	};

	/**
	 * Render a custom dropbox from commerce7 default filter selects.
	 *
	 * @param {Node} collection
	 */
	const makeFilters = (collection) => {
		// /* Make filters using c7 api */
		// const slug = collection.dataset.collectionSlug;
		// const fetchPromises = wineFilter.map((filter) =>
		// 	fetchFilterOptions(slug, filter.fetchLink)
		// );

		// Promise.all(fetchPromises).then((data) => {
		// 	const html = wineFilter.reduce(
		// 		(acc, filter, index) => (
		// 			(acc += makeSelection(
		// 				data[index],
		// 				filter.name,
		// 				filter.label
		// 			)),
		// 			acc
		// 		),
		// 		""
		// 	);

		// 	const container = collection.querySelector(
		// 		selectors.filterContainer
		// 	);
		// 	container.innerHTML = html;
		// });

		/* Make filters from wines html. */
		const slug = collection.dataset.collectionSlug;
		winesData[slug] = [];

		collection
			.querySelectorAll(selectors.productInformation)
			.forEach((wineInformation) => {
				const row = wineFilter.reduce(
					(acc, filter) => (
						(acc[filter.name] = wineInformation.querySelector(
							`.${filter.fetchLink}`
						).innerHTML),
						acc
					),
					{}
				);
				winesData[slug].push(row);
				$(wineInformation).remove();
			});

		const filterOptions = winesData[slug].reduce((acc, wine) => {
			for (let name in wine) {
				if (!acc[name]) {
					acc[name] = [];
				}
				if (wine[name]) {
					acc[name].push(wine[name]);
				}
			}
			return acc;
		}, {});

		for (let name in filterOptions) {
			filterOptions[name] = [...new Set(filterOptions[name])].sort(); // Unique & sort.
		}

		const html = wineFilter.reduce(
			(acc, filter) => (
				(acc += makeSelection(
					filterOptions[filter.name],
					filter.name,
					filter.label
				)),
				acc
			),
			""
		);

		collection.querySelector(selectors.filterContainer).innerHTML = html;
	};

	/**
	 * Fetch filter options from Commerce7
	 *
	 * @param {string} slug Collection slug.
	 * @param {string} filter Wine filter name.
	 */
	const fetchFilterOptions = async (slug, filter) => {
		const response = await fetch(
			`${C7BaseUrl}/product-filter-for-web/${filter}?collectionSlug=${slug}`,
			{
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					tenant: theme_object.tenant,
				},
			}
		);
		return await response.json();
	};

	/**
	 * Make filter selectbox from options
	 *
	 * @param {Array} options
	 * @param {string} name Name of the filter, also the key of the each option value
	 * @param {string} label
	 */
	const makeSelection = (options, name, label) => {
		if (!options || options.length < 2) {
			return "";
		}

		let str = `<div><input class="all" type="checkbox" name="${name}" value="All" checked><span>All</span></div>`;
		options.forEach((option) => {
			const value = option[name] ? option[name] : option;
			str += `<div><input type="checkbox" name="${name}" value="${value}"><span>${value}</span></div>`;
		});
		return `<div class="c7-selectbox"><label>${label}<sup class="selected"></sup></label><div class="c7-selectbox__inner">${str}</div></div>`;
	};

	/**
	 * Rigister event handlers.
	 */
	const registerEventHandlers = () => {
		$(document).on("click", selectors.clearFilter, clearActiveFilters);
		$(document).on("click", selectors.filterInput, onFilterCheckboxClick);
		$(document).on("click", selectors.sortInput, onSortInputClick);
		$(document).on("click", selectors.selectboxLabel, mobileSelectBoxToggle);
		$(document).on("click", selectors.close, mobileCloseFilter);
		$(document).on("click", selectors.open, mobileOpenFilter);
		$(document).on("keyup", selectors.searchInput, onSearchKeyUpdate);
		$(document).on("click", selectors.clearSearch, onClearSearch);
	};

	const onClearSearch = (e) => {
		const collection = $(e.target).closest(selectors.collection)
		collection.find(selectors.searchInput).val('')
		doFilteringAction(e.target)
		collection.find(selectors.clearSearch).hide()
	}

	const onSearchKeyUpdate = (e) => {
		const s = e.target.value.trim().toLowerCase();
		const collection = $(e.target).closest(selectors.collection)
		if (s) {
			collection.find(selectors.clearSearch).show()
			searchProducts(e.target)
		} else {
			collection.find(selectors.clearSearch).hide()
			doFilteringAction(e.target)
		}
	}

	const searchProducts = function (target) {
		const collection = $(target).closest(selectors.collection)
		const selector = window.innerWidth < 1300 ? '.for-small-screen ' : '.for-big-screen '
		const searchKey = collection.find(selector + selectors.searchInput).val()
		let visibleWinesCount = 0
		if (searchKey) {
			const wines = collection.find(selectors.product);
			wines.each((_, wine) => {
				const content = $(wine).find(".c7-product__title a").text().toLowerCase()
				if ( -1 === content.indexOf(searchKey)) {
					$(wine).hide()
				} else {
					$(wine).show()
					visibleWinesCount ++
				}
			})
		}
		checkSearchResult(target, visibleWinesCount)
	}

	const checkSearchResult = (target, visibleWinesCount) => {
		const collection = $(target).closest(selectors.collection)
		const wines = collection.find(selectors.product)
		collection.find(selectors.banner).hide()
		if (visibleWinesCount) {
			collection.find(selectors.noResult).hide()

			if (visibleWinesCount === wines.length) {
				collection.find(selectors.banner).show()
			}
		} else {
			collection.find(selectors.noResult).show()
		}
	}

	const mobileSelectBoxToggle = function () {
		if (window.innerWidth < 1300) {
			$(this).parent().find(".c7-selectbox__inner").toggle();
		}
	};

	const mobileCloseFilter = function () {
		$(".collection__filter__inner").fadeOut(300);
		setTimeout(() => {
			$(".c7-product-collection__filter").removeClass("active");
		});
	};

	const mobileOpenFilter = () => {
		$(".c7-product-collection__filter").addClass("active");
		$(".collection__filter__inner").fadeIn(300);
	}

	const onFilterCheckboxClick = (e) => {
		const input = $(e.target);
		const filter = input.closest(selectors.filter);

		// Clicking "All" checkbox clears other selected options.
		if (input.hasClass("all")) {
			input.prop("checked", true);
			filter.find(selectors.filterInputOption).prop("checked", false);
		}

		// Add a mark to the filter if it has selected options.
		const selected = filter.find(selectors.filterInputSelected);
		if (selected.length) {
			filter.addClass("active");
			filter.find(".selected").html(selected.length);
			filter.find(selectors.filterInputAll).prop("checked", false);
		} else {
			filter.removeClass("active");
			filter.find(".selected").empty();
			filter.find(selectors.filterInputAll).prop("checked", true);
		}

		// Handling "Clear Filters" button visibility.
		const collection = filter.closest(selectors.collection);
		if (collection.find(selectors.filterInputSelected).length) {
			collection.find(selectors.clearFilter).addClass("show");
		} else {
			collection.find(selectors.clearFilter).removeClass("show");
		}

		// Do filtering action.
		doFilteringAction(e.target);
	};

	/**
	 * Clear active collection filters.
	 */
	const clearActiveFilters = (e) => {
		const collection = $(e.target).closest(selectors.collection);
		const container = collection.find(selectors.filterContainer);

		// Hide self.
		e.target.classList.remove("show");

		// Reset all checkboxes.
		container.find(selectors.filterInputAll).prop("checked", true);
		container.find(selectors.filterInputOption).prop("checked", false);

		// Reset filter active mark.
		container.find(selectors.filter).removeClass("active");
		container.find(selectors.filter).find(".selected").empty();

		// Show all wines.
		collection.find(selectors.product).show();
		collection.find(selectors.noResult).hide();

		// Show Banner.
		$(selectors.banner).show();
	};

	const onSortInputClick = (e) => {
		const input = $(e.target);
		const sort = input.closest(selectors.sort);

		// Exclude selections.
		if (input.is(":checked")) {
			sort.find("input").prop("checked", false);
			input.prop("checked", true);
		}

		// Cannot uncheck "None" once checked.
		if (input.hasClass("all")) {
			input.prop("checked", true);
		}

		// Add a mark to the sort if it has selected options.
		const selected = sort.find(selectors.filterInputSelected);
		if (selected.length) {
			sort.addClass("active");
			sort.find(".selected").html(1);
			sort.find(selectors.filterInputAll).prop("checked", false);
		} else {
			sort.removeClass("active");
			sort.find(".selected").empty();
			sort.find(selectors.filterInputAll).prop("checked", true);
		}

		const wines = sort
			.closest(selectors.collection)
			.find(selectors.product);

		switch (selected.val()) {
			case "priceup":
				$(selectors.banner).hide();
				wines.each((_, wine) => {
					$(wine).css("order", $(wine).data("price-order"));
				});
				break;
			case "pricedown":
				$(selectors.banner).hide();
				wines
					.not(".c7-product--featured")
					.each((_, wine) =>
						$(wine).css(
							"order",
							wines.length - $(wine).data("price-order")
						)
					);

				break;
			default:
				$(selectors.banner).show();
				wines.each((_, wine) => $(wine).css("order", "initial"));
		}
	};

	/**
	 * Do filtering action of the current collection.
	 *
	 * @param {Node} target Event target.
	 */
	const doFilteringAction = (target) => {
		const collection = $(target).closest(selectors.collection);
		const slug = collection.data("collection-slug");
		const wines = collection.find(selectors.product);

		const activeFilters = [];
		collection.find(selectors.filterInputSelected).each((_, filter) => {
			console.log(filter.name, activeFilters[filter.name]);
			if (!activeFilters[filter.name]) {
				activeFilters[filter.name] = [];
			}
			console.log(activeFilters[filter.name]);
			activeFilters[filter.name].push(filter.value);
		});

		let visibleWinesCount = 0;
		winesData[slug].forEach((data, index) => {
			for (let name in activeFilters) {
				if (!(data[name] && activeFilters[name].includes(data[name]))) {
					wines.eq(index).hide();
					return;
				}
			}
			wines.eq(index).show();
			visibleWinesCount++;
		});

		searchProducts(target);
		checkSearchResult(target, visibleWinesCount);
	};
}
